import styled from "styled-components"; 


export const ContainerModalToken = styled.div`
    width: 100%;
    height: 250px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 40px;
    span {
        width: 360px;
        font-weight: 400;
        line-height: 150%;
        color: var(--color-latex10);
        font-size: 18px;
    }
    .btn {
        padding: 12px 26px;
        font-size: 18px;
        background-color: var( --color-broccoli);
        color: var(--color-white);
    }
`;